import type {SafeHTMLString} from '@github-ui/safe-html'
import {useSafeAsyncCallback} from '@github-ui/use-safe-async-callback'
import {useCallback, useEffect, useRef, useState} from 'react'

// Manage preview state and loading of preview HTML asynchronously from markdown input.
export function usePreview(value: string, onRenderPreview: (markdown: string) => Promise<SafeHTMLString>) {
  const [html, setHtml] = useState<SafeHTMLString | null>(null)
  const safeSetHtml = useSafeAsyncCallback(setHtml)
  const previewStale = useRef(true)

  useEffect(() => {
    previewStale.current = true
  }, [value])

  const loadPreview = useCallback(async () => {
    if (!previewStale.current) return
    previewStale.current = false
    safeSetHtml(null)
    safeSetHtml(await onRenderPreview(value))
  }, [value, onRenderPreview, safeSetHtml])

  return {html, setHtml, loadPreview, previewStale}
}
